import React from 'react';
import { Link } from 'react-router-dom';

const TestListPage = () => {
    const items = Array.from({ length: 50 }, (_, i) => ({ id: i + 1, title: `Item ${i + 1}` }));

    return (
        <div className="min-h-screen bg-[var(--bg-main)] text-[var(--text-main)] p-8 flex justify-center transition-colors duration-300">
            <div className="max-w-2xl w-full">
                <h1 className="text-3xl font-bold mb-2 text-indigo-400">Scroll Restoration Test</h1>
                <p className="text-slate-400 mb-8 pb-6 border-b border-slate-800">
                    Scroll down and click an item. Then go back. You should be at the same scroll position.
                </p>
                <div className="flex flex-col gap-4">
                    {items.map((item) => (
                        <Link
                            key={item.id}
                            to={`/test-detail/${item.id}`}
                            className="p-6 bg-slate-900 border border-slate-800 hover:border-indigo-500/50 hover:bg-slate-800 rounded-2xl transition-all block group shadow-sm hover:shadow-md"
                        >
                            <h2 className="text-xl font-bold text-slate-100 group-hover:text-indigo-400 transition-colors">{item.title}</h2>
                            <p className="text-sm text-slate-500 mt-1">Click to view details for {item.title}</p>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TestListPage;
